// prod
export const API_URL = 'https://copperfleet.com/tenant/';

// dev
// export const API_URL = 'http://localhost:8001/tenant/';
